import { ReactNode, useContext, useState } from "react";
import Auth, { AuthProps } from "../../api/auth";
import AuthCodeApi from "../../api/auth-code";
import AuthCode from "../../types/auth-code";
import AuthContext from "../auth-context";
import { ActiveTab } from "./active-tab";
import Login from "./login";

export interface LoginContainerProps {
  children: ReactNode;
}

const LoginContainer = ({ children }: LoginContainerProps) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [customerType, setCustomerType] = useState("Person");

  const [loginAlert, setLoginAlert] = useState(false);
  const [forgotAlert, setForgotAlert] = useState(false);
  const [resetAlert, setResetAlert] = useState(false);

  const [activeTab, setActiveTab] = useState<ActiveTab>("login");
  const context = useContext(AuthContext);

  const clearAlerts = () => {
    setLoginAlert(false);
    setForgotAlert(false);
    setResetAlert(false);
  };

  const handleActiveTabChange = (tab: ActiveTab) => {
    clearAlerts();
    setActiveTab(tab);
  };

  const handleLogin = (data: AuthProps) => {
    setLoginAlert(false);

    Auth.login(data).then((response) => {
      if (response.LoginId) {
        context.login(response.LoginId);
      } else {
        setLoginAlert(true);
      }
    });
  };

  const handleForgot = (data: AuthCode) => {
    setForgotAlert(false);
    setUsername(data.username);

    const api = new AuthCodeApi();
    api.post(data).then((response) => {
      if (response.errorMessage) {
        setForgotAlert(true);
      } else {
        setResetAlert(false);
        setActiveTab("reset");
      }
    });
  };

  const handleReset = (data: AuthCode) => {
    setResetAlert(false);

    const api = new AuthCodeApi();
    api.put(data).then((response) => {
      if (response.errorMessage) {
        setResetAlert(true);
      } else {
        setResetAlert(false);
        handleLogin({
          username: data.username,
          password: data.code!,
          serviceType: "0",
        });
      }
    });
  };

  const handleCustomerTypeToggle = () => {
    setCustomerType((c) => (c === "Person" ? "Company" : "Person"));
    setUsername("");
    setPassword("");
    clearAlerts();
    setActiveTab("login");
  };

  return context.authId ? (
    <>{children}</>
  ) : (
    <Login
      activeTab={activeTab}
      loginAlert={loginAlert}
      forgotAlert={forgotAlert}
      resetAlert={resetAlert}
      customerType={customerType}
      username={username}
      password={password}
      onActiveTabChange={handleActiveTabChange}
      onCustomerTypeToggle={handleCustomerTypeToggle}
      onUsernameChange={setUsername}
      onPasswordChange={setPassword}
      onForgotPassword={handleForgot}
      onResetPassword={handleReset}
      onLogin={handleLogin}
    />
  );
};

export default LoginContainer;
